import { c as _c } from "react/compiler-runtime";
import type { JSX } from "react";
interface PhotoAttributionProps {
  attribution: string | null;
  attributionUri: string | null;
}
export function PhotoAttribution(t0) {
  const $ = _c(5);
  const {
    attribution,
    attributionUri
  } = t0;
  if (!attribution) {
    return null;
  }
  let t1;
  if ($[0] !== attribution || $[1] !== attributionUri) {
    t1 = attributionUri ? <a href={attributionUri} target="_blank" rel="noopener noreferrer" className="underline">{attribution}</a> : attribution;
    $[0] = attribution;
    $[1] = attributionUri;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <figcaption className="typography-body-xs-regular text-text-secondary">Source:{" "}{t1}{" "}· Google</figcaption>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}